import React from "react";
import { useTranslation } from "react-i18next";
import { getEyeStyle } from "components/common/TableColor";

/** Status pill: tinted background, solid border/text in the status colour. */
const StatusBadge = ({ status, billable = false }) => {
  const { t } = useTranslation();
  if (!status) return null;

  const normalized = String(status).toLowerCase();
  const color = getEyeStyle(normalized)?.background || "#6F8DFF";
  let label = t(`status.${normalized}`, { defaultValue: status });
  if (normalized === "cancelled" && billable) {
    label = `${label} (${t("appointmentView.billable")})`;
  }

  return (
    <span className="appt-badge" style={{ "--badge": color }}>
      {label}
    </span>
  );
};

export default StatusBadge;
